import { _ as _extends } from './extends-a2cb9f0c.esm.js';
import { Formik, useFormikContext } from 'formik';
import React__default, { forwardRef, useImperativeHandle, useEffect, useCallback } from 'react';
import { View } from 'react-native';
import { s as shallowCompare } from './index-b141c75b.esm.js';
import { A as AppButton } from './AppButton-a3bdb006.esm.js';
import { u as useTheme } from './useTheme-90e8e2c2.esm.js';

const AppForm = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    initialValues,
    onSubmit,
    validationSchema,
    onValuesChange,
    children,
    requiresReset,
    style,
    ...props
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Formik, _extends({
    initialValues: initialValues,
    onSubmit: (v, _ref2) => {
      let {
        resetForm
      } = _ref2;
      const isChanged = !shallowCompare(initialValues, v);
      onSubmit(v, isChanged);
      requiresReset && resetForm();
    },
    validationSchema: validationSchema
  }, props), formikProps => {
    const {
      resetForm,
      values
    } = formikProps;
    useImperativeHandle(ref, () => ({
      resetForm
    }));
    useEffect(() => {
      return () => {
        resetForm();
      };
    }, []);
    useEffect(() => {
      onValuesChange && onValuesChange(values);
    }, [JSON.stringify(values)]);
    return /*#__PURE__*/React__default.createElement(View, {
      style: style
    }, children);
  });
});
AppForm.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppForm"
};

function AppSubmitButton(_ref) {
  let {
    title,
    isDisabled,
    isEnabledOnFilled = false,
    onSubmitButtonEnabled = () => {},
    onSubmit = () => {},
    forceEnabled = false,
    ...props
  } = _ref;
  const {
    values,
    submitForm,
    isValid,
    dirty
  } = useFormikContext();
  const _isDisabled = !(isValid && (dirty || isEnabledOnFilled)) || isDisabled;
  const {
    currentTheme
  } = useTheme();
  const {
    isDeletion,
    mode
  } = props;
  useEffect(() => {
    onSubmitButtonEnabled(isValid && dirty && !isDisabled);
  }, [isValid && dirty]);
  const generateBtnFontColor = useCallback(() => {
    if (_isDisabled && !forceEnabled) {
      var _currentTheme$theme;
      return currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.white;
    } else if (isDeletion) {
      var _currentTheme$theme2;
      return currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme2 = currentTheme.theme) === null || _currentTheme$theme2 === void 0 ? void 0 : _currentTheme$theme2.red;
    } else {
      var _currentTheme$theme3;
      return currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme3 = currentTheme.theme) === null || _currentTheme$theme3 === void 0 ? void 0 : _currentTheme$theme3.black;
    }
  }, [_isDisabled, isDeletion, mode, forceEnabled, isDisabled]);
  return /*#__PURE__*/React__default.createElement(AppButton, _extends({}, props, {
    title: title,
    fontColor: generateBtnFontColor(),
    isDisabled: !forceEnabled && _isDisabled,
    onPress: () => {
      submitForm();
      onSubmit();
    }
  }));
}
AppSubmitButton.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppSubmitButton",
  "props": {
    "isEnabledOnFilled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "onSubmitButtonEnabled": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "onSubmit": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "forceEnabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    }
  }
};

export { AppForm as A, AppSubmitButton as a };
